import POIStep from "@/components/POI/POIStep/POIStep.vue";
import POIGeneralStateField from "@/components/POI/POIStateFields/POIGeneralStateField/POIGeneralStateField.vue";
export default {
  name: "POIGeneralState",
  components: { POIStep, POIGeneralStateField },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
